import { Injector } from "@angular/core";
import { PaginationControl } from "../../PaginationControl";
import { QueryNode } from "../QueryNode";
import { ServiceEnum } from "../../ServiceEnum";
import { TreeNode } from "primeng/api";
import { SectionService } from "../../../service/section-service/section-service";
import { DynamicListView } from "../../Data/DynamicListView";
import { DateUtil } from "../../DateUtil";
import { Art57NodeUtils } from "../Art57Node/Art57NodeUtils";
import { BaseNode } from "../BaseNode";
import { ResultList } from "../ListEntity/ResultList";
import { QueryResultNode } from "../QueryResultNode";
import { MedicinalProductsQueryResultNode } from "./MedicinalProductsQueryResultNode";
import { QueryConditionsNode } from "../QueryConditionsNode";
import { QueryFieldsNode } from "../QueryFieldsNode";

export class MedicinalProductsSimpleQueryNode extends QueryNode {

    paginationControl?: PaginationControl;

    constructor(injector: Injector, data: any, labelTemplate: string, entityName: string) {
        super(injector, data, labelTemplate, [], [], entityName, ServiceEnum.MedicinalProducts, null);
        this.children = [];
    }

    override processResult(pageToRetrieve: PaginationControl, nodeRequest: BaseNode, data: any): void {
        let resultNodeList: TreeNode | null = Art57NodeUtils.findFirstChildNodeOfType(this, ResultList);
        let resultNode = null;
        if (resultNodeList) {

            if ((!(nodeRequest instanceof ResultList)) && (!(nodeRequest instanceof QueryResultNode))) {
                // This is the RUN scenario
                if (data && (data.length > 0)) {
                    const listViewInstance = new DynamicListView(data, this.getFieldsToShow());
                    const fieldsNode: QueryFieldsNode = (Art57NodeUtils.findFirstChildNodeOfType(this, QueryFieldsNode) as QueryFieldsNode);
                    const conditionsNode: QueryConditionsNode = (Art57NodeUtils.findFirstChildNodeOfType(this, QueryConditionsNode) as QueryConditionsNode);
                    resultNode = new MedicinalProductsQueryResultNode(this.ioc!, listViewInstance, "Result " + DateUtil.getResultDateTime(), this.entityName, fieldsNode, conditionsNode);
                    resultNode.paginationControl = pageToRetrieve;
                    resultNode.parent = resultNodeList;
                    resultNodeList.children?.push(resultNode);
                    this.ioc!.get(SectionService).selectMedicinalProductsNode(resultNode);
                }

            } else {
                // This is the RERUN scenario
                nodeRequest.data.model = data;
                resultNode = nodeRequest;
                this.ioc!.get(SectionService).selectMedicinalProductsNode(resultNode);
            }

        }
    }
}